<template>
  <div class="wrapper">
    <div>
      <c-row>
        <c-col col="12">
          <c-card>
            <c-card-header>
              <c-icon name="cil-justify-center" />
              Bootstrap Modals
              <div class="card-header-actions">
                <a
                  href="https://coreui.io/vue/docs/components/modal"
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <small class="text-muted">docs</small>
                </a>
              </div>
            </c-card-header>
            <c-card-body>
              <c-button color="secondary" class="mr-1" @click="myModal = true">
                Launch demo modal
              </c-button>
              <c-button color="secondary" class="mr-1" @click="largeModal = true">
                Launch large modal
              </c-button>
              <c-button color="secondary" class="mr-1" @click="smallModal = true">
                Launch small modal
              </c-button>
              <hr />
              <c-button color="primary" class="mr-1" @click="primaryModal = true">
                Launch primary modal
              </c-button>
              <c-button color="success" class="mr-1" @click="successModal = true">
                Launch success modal
              </c-button>
              <c-button color="warning" class="mr-1" @click="warningModal = true">
                Launch warning modal
              </c-button>
              <c-button color="danger" class="mr-1" @click="dangerModal = true">
                Launch danger modal
              </c-button>
              <c-button color="info" class="mr-1" @click="infoModal = true">
                Launch info modal
              </c-button>
              <c-button color="dark" class="mr-1" @click="darkModal = true">
                Launch dark modal
              </c-button>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </div>
    <!-- Modal Component -->
    <c-modal title="Modal title" :show.sync="myModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal title="Modal title" size="lg" :show.sync="largeModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal title="Modal title" size="sm" :show.sync="smallModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>

    <c-modal title="Modal title" :show.sync="primaryModal" color="primary">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal title="Modal title" color="success" :show.sync="successModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal title="Modal title" color="warning" :show.sync="warningModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal title="Modal title" color="danger" :show.sync="dangerModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal title="Modal title" color="info" :show.sync="infoModal">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </c-modal>
    <c-modal
      :show.sync="darkModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
    >
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      <template #header>
        <h6 class="modal-title">Custom smaller modal title</h6>
        <c-button-close class="text-white" @click="darkModal = false" />
      </template>
      <template #footer>
        <c-button color="danger" @click="darkModal = false">Discard</c-button>
        <c-button color="success" @click="darkModal = false">Accept</c-button>
      </template>
    </c-modal>
  </div>
</template>

<script>
export default {
  name: 'Modals',
  data() {
    return {
      myModal: false,
      largeModal: false,
      smallModal: false,
      primaryModal: false,
      successModal: false,
      warningModal: false,
      dangerModal: false,
      infoModal: false,
      darkModal: false,
    };
  },
};
</script>
